import type { SupabaseClient } from "@supabase/supabase-js";

import type {
  ExecutionLink,
  ExecutionLinkRepository,
} from "./executionLinkRepository";

function fromRow(row: Record<string, unknown>): ExecutionLink {
  return {
    executionJobId: String(row.execution_job_id),

    executionId: String(row.execution_id),

    programId: String(row.program_id),

    workItemId: String(row.work_item_id),

    department: String(row.department),

    agentId: String(row.agent_id),

    createdAt: String(row.created_at),
  };
}

export class SupabaseExecutionLinkRepository implements ExecutionLinkRepository {
  constructor(private readonly supabase: SupabaseClient) {}

  async save(link: ExecutionLink) {
    const { error } = await this.supabase.from("cyan_execution_links").upsert({
      execution_job_id: link.executionJobId,

      execution_id: link.executionId,

      program_id: link.programId,

      work_item_id: link.workItemId,

      department: link.department,

      agent_id: link.agentId,

      created_at: link.createdAt,
    });

    if (error) {
      throw new Error(`Unable to save execution link: ${error.message}`);
    }
  }

  async getByJobId(executionJobId: string) {
    const { data, error } = await this.supabase
      .from("cyan_execution_links")
      .select("*")
      .eq("execution_job_id", executionJobId)
      .maybeSingle();

    if (error) {
      throw new Error(`Unable to read execution link: ${error.message}`);
    }

    return data ? fromRow(data) : null;
  }

  async getByExecutionId(executionId: string) {
    const { data, error } = await this.supabase
      .from("cyan_execution_links")
      .select("*")
      .eq("execution_id", executionId)
      .maybeSingle();

    if (error) {
      throw new Error(`Unable to read execution link: ${error.message}`);
    }

    return data ? fromRow(data) : null;
  }
}
